import { useState } from "react";
import { FaSearch } from "react-icons/fa";
import Button from "shared/components/Button";
import Input from "shared/components/Input";

const SearchBar = ({
  onSearch,
  canSearchByAdvisor,
  translate,
  initialSearch = {},
}) => {
  const [search, setSearch] = useState(initialSearch);

  const bindField = (field) => ({
    defaultValue: initialSearch[field],
    onChange: ({ target: { value } }) =>
      setSearch((prev) => ({ ...prev, [field]: value })),
  });

  return (
    <div className="search--bar">
      <Input
        placeholder={translate.CLIENT_QUERY}
        {...bindField("clientQuery")}
        onPressEnter={() => onSearch(search)}
      />
      {canSearchByAdvisor && (
        <>
          <Input
            placeholder={translate.ADVISOR_LAST_NAME}
            {...bindField("advisorLastName")}
          />
          <Input
            placeholder={translate.ADVISOR_FIST_NAME}
            {...bindField("advisorFirstName")}
          />
        </>
      )}
      <Button
        type="secondary"
        onClick={() => onSearch(search)}
        icon={<FaSearch size={14} />}
        size={"full--w"}
      >
        {translate.FILTER}
      </Button>
    </div>
  );
};

export default SearchBar;
